"use client";

import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Lightbulb, Cog, Rocket } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServicesOverview() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const services = [{
    icon: Lightbulb,
    title: "AI Strategy Advisory",
    description: "Enterprise-level roadmap development aligned with board priorities, capital allocation strategy, and long-term competitive positioning."
  }, {
    icon: Cog,
    title: "Governance & Risk Oversight",
    description: "Structured frameworks to manage regulatory exposure, model accountability, data governance, and executive-level reporting integrity."
  }, {
    icon: Rocket,
    title: "Implementation & Scaling Oversight",
    description: "Independent advisory supervision to ensure AI initiatives deploy responsibly, integrate correctly, and scale sustainably."
  }];
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section id="services-overview" className="dark bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const IconComponent = service.icon;
          return <div key={i} data-index={i} ref={refs[i]} className={`transition-all duration-[var(--duration-medium)] flex ${visibilities[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full w-full flex flex-col justify-center bg-secondary backdrop-blur-lg border border-white/20 rounded-lg shadow-soft hover:shadow-medium hover:-translate-y-1 hover:border-2 hover:border-primary/40 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group">
                  <CardHeader className="flex flex-col items-center text-center pt-8">
                    <div className="mb-4 transition-transform duration-300 group-hover:rotate-6">
                      <IconComponent className="w-16 h-16 text-primary-dark" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-xl font-display font-bold text-foreground">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="text-center pb-8">
                    <CardDescription className="text-muted-foreground leading-relaxed">
                      {service.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}